var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5724 10.2408V5.81748C15.5724 5.39404 15.2291 5.05078 14.8057 5.05078V5.05078M0.429688 10.2408L0.429688 5.81909C0.429688 5.39477 0.773673 5.05078 1.198 5.05078V5.05078",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1922 12.0895L15.5672 12.0895V11.7145V8.9942V8.61924H15.1922L12.0569 8.61924C11.2995 8.61924 10.6855 9.23322 10.6855 9.9906V10.7181C10.6855 11.4755 11.2995 12.0895 12.0569 12.0895L15.1922 12.0895ZM0.428551 8.33914C0.428551 7.59252 1.0338 6.98727 1.78042 6.98727H14.2197C14.9663 6.98727 15.5716 7.59252 15.5716 8.33914V13.4619C15.5716 14.2086 14.9663 14.8138 14.2197 14.8138H1.78042C1.0338 14.8138 0.428551 14.2086 0.428551 13.4619V8.33914Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.749925
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05347 2.68262L12.0185 1.78908C12.4404 1.71315 12.845 1.99035 12.9265 2.41117L13.2704 4.18666",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13795 2.68539C2.30977 1.91106 3.07678 1.42264 3.8511 1.59447L13.2991 3.69103C14.0734 3.86286 14.5619 4.62986 14.39 5.40419L14.2133 6.20084C14.1546 6.19472 14.095 6.19158 14.0347 6.19158H5.81441L2.30115 5.41197L2.12815 6.19158H1.78685C1.6348 6.19158 1.48742 6.21153 1.34717 6.24897L2.13795 2.68539ZM13.6578 5.24171L13.5486 5.73393L2.76091 3.34009L2.87013 2.84786C2.95223 2.47792 3.31868 2.24457 3.68862 2.32666L13.1366 4.42322C13.5066 4.50531 13.7399 4.87176 13.6578 5.24171Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7f694dfdcf8d2558f34ef5258bb8860d.svg";
export { ForwardRef as ReactComponent };